import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import "./Announcement.css";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
    makeAnnouncement,
    setIsSuperSpeakerActive
} from "../../store/Announcement/AnnouncementSlice.js";
import { addNotification } from "../../../Notifications/store/notificationsSlice.js";
import NotificationBuilder from "../../../Notifications/utils/NotificationBuilder.js";

const Announcement = ({ onCancel }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { localAvatar } = useSelector(state => state.auth);

  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevTime) => prevTime - 1);
      }
      , 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);
  


  const handleContinue = () => {
    const announcerName = localAvatar?.display_name || localAvatar?.name || localAvatar?.username || 'Someone';


    dispatch(makeAnnouncement({
      announcerName,
      message: t("activating_global_announcement"),
      severity: "info",
      isLive: false,
    }));

    const notification = NotificationBuilder.info()
    .withHeader('activating_global_announcement', true)
    .build()
    dispatch(addNotification(notification));

    dispatch(setIsSuperSpeakerActive(true));

    // Close the dialog
    onCancel();
  };

  

  return (
    <div>

      <DialogContent className="dialog-content">
        <Typography className="dialog-text">
          {t("announcement_dialog_text")}
        </Typography>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button className="cancel-button" onClick={onCancel}>
          {t("cancel")}
        </Button>
        <Button
          variant="contained"
          className="continue-button"
          onClick={handleContinue}
          disabled={countdown > 0}
        >
          {countdown <= 0 ? t("continue") : `${t("continue")} (${countdown}s)`}
        </Button>
      </DialogActions>
    </div>
  );
};

export default Announcement;
